'use client';

import { ToastContainer } from 'react-toastify';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const StyledToastContainer = styled(ToastContainer).attrs({
  toastClassName: 'styled-toast',
})`
  display: flex;
  pointer-events: none;
  z-index: 99;

  .Toastify__toast-icon {
    margin-inline-end: 0;
  }

  .styled-toast {
    color: ${({ theme }) => theme.colors.typographyBodyLight};
    border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
    border-radius: ${Spacers.XS}rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${Spacers.BASE}rem;
    width: 100%;
    box-shadow: none;
    padding: 1rem;
    pointer-events: auto;
  }
`;
